import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ListaSucursales } from '../Comunes/Listas';
const Usuarios = (props) => {

    const MySwal = withReactContent(Swal);

    const NuevousuarioLocal = async () => {

        const { value: formValues } = await MySwal.fire({
            title: 'Nuevo Usuario ',
            html: (
                <div>

                    <select id="AgrSucursal" name="AgrSucursal" className="form-group">
                        {ListaSucursales.map((option, i) => (
                            <option key={i} value={option.value}>{option.span}</option>
                        ))}</select>
                    <input id="swal-nombre" autoComplete='off' className="swal2-input" placeholder="Nombre" />
                    <input id="swal-usuario" autoComplete='off' className="swal2-input" placeholder="Usuario" />
                    <input id="swal-correo" autoComplete='off' className="swal2-input" placeholder="Correo" />
                    <input id="swal-clave" autoComplete='off' className="swal2-input" placeholder="Contraseña" />
                </div>
            ),
            focusConfirm: false,
            preConfirm: () => {
                const COD_Sucursal = document.getElementById('AgrSucursal').value;
                const Nombreusuario = document.getElementById('swal-nombre').value;
                const UserName = document.getElementById('swal-usuario').value;
                const clave = document.getElementById('swal-clave').value;
                const correo = document.getElementById('swal-correo').value;
                if (!COD_Sucursal || !Nombreusuario || !UserName || !clave || !correo) {
                    Swal.showValidationMessage('Todos los campos son requeridos');
                    return false;
                }
                return { CODIGO: 0, USUARIO: UserName, NOMBRE: Nombreusuario, SUCURSAL: COD_Sucursal, CLAVE: clave, CORREO: correo };
            }
        });

        if (formValues) {
            props.AgregarUsuario(formValues)

        }

    }

    return (<>
        <h4>Usuarios</h4>
        <div className="info" style={{ overflowX: 'auto' }}>
            <button style={{ maxWidth: '70px' }} onClick={() => NuevousuarioLocal()}>Nuevo</button>
            <table id="tablaClientes" name="tablaClientes" className="table-striped table table-sm'">
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Usuario</th>
                        <th>Nombre</th>
                        <th>Sucursal</th>
                        <th>Correo</th>
                        <th>Clave</th>
                        <th>Reset Clave</th>
                        <th>Eliminar</th>
                    </tr>
                </thead>
                <tbody>
                    {props.Losusuarios ? props.Losusuarios.map((post, index) => {
                        return <tr key={index}>
                            <td>{post.CODIGO}</td>
                            <td><input name='USUARIO' type='text' value={post.USUARIO} onChange={props.ActualizarUsuario(index)}></input> </td>
                            <td><input name='NOMBRE' type='text' value={post.NOMBRE} onChange={props.ActualizarUsuario(index)}></input> </td>
                            <td><select id="SUCURSAL" name="SUCURSAL" className="form-group" onChange={props.ActualizarUsuario(index)} value={post.SUCURSAL}>
                            {ListaSucursales.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}</select></td>
                            <td><input name='CORREO' type='text' value={post.CORREO} onChange={props.ActualizarUsuario(index)}></input> </td>
                            <td><input name='CLAVE' type='text' value={post.CLAVE} onChange={props.ActualizarUsuario(index)}></input> </td>
                            <td><button onClick={() => props.ResetearClave(index)} >Reset. Clave</button></td>
                            
                            <td><button onClick={() => props.EliminarUsuario(index)} >Eliminar</button></td>
                        </tr>
                    }) : null}
                </tbody>
            </table>
        </div>

    </>)

}
export default Usuarios;